var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#2d7c8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.74,34.51c-8.41,0-15.26-6.84-15.26-15.26s6.84-15.26,15.26-15.26,15.26,6.84,15.26,15.26-6.84,15.26-15.26,15.26Zm0-28.13c-7.1,0-12.88,5.78-12.88,12.88s5.78,12.88,12.88,12.88,12.88-5.78,12.88-12.88-5.78-12.88-12.88-12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.79,46c-.46,0-.91-.17-1.26-.52-.7-.7-.7-1.83,0-2.53l14.49-14.49c.7-.7,1.83-.7,2.53,0,.7,.7,.7,1.83,0,2.53l-14.49,14.49c-.35,.35-.81,.52-1.26,.52Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassIcon);
export default __webpack_public_path__ + "static/media/magnifying-glass-icon.7c92dd66a0a72bd71f045c4615c657d0.svg";
export { ForwardRef as ReactComponent };